<section class="p95-utilization-page">
  <div class="mx-auto w-full max-w-7xl px-5 py-6 md:px-8">
    <div
      class="mb-4 flex flex-col items-center justify-between gap-4 md:flex-row"
    >
      <h1>
        95th Percentile Bandwidth Utilization
        <button
          type="button"
          class="inline-flex h-7 w-7 items-center justify-center rounded-full text-black transition hover:bg-gray-100"
          matTooltip="This 95th percentile bandwidth utilization report summarizes network usage by measuring bandwidth over 10-min intervals, discarding the top 5% of the highest usage samples, and reporting the highest remaining value."
          matTooltipPosition="below"
          aria-label="About 95th Percentile Bandwidth Utilization report"
        >
          <mat-icon class="!text-[20px]">info_outline</mat-icon>
        </button>
      </h1>
    </div>

    <div class="p95-content-layout">
      <div
        class="flex w-full flex-col items-stretch overflow-hidden rounded-xl bg-white pb-4 shadow-sm"
      >
        <div class="flex flex-wrap items-center justify-between gap-2 p-4">
          <div class="relative">
            <input
              type="text"
              placeholder="Search"
              class="h-12 rounded-lg border border-gray-300 bg-white px-4 py-2 pr-10 text-sm font-medium text-gray-700 placeholder-gray-500 hover:bg-gray-50 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
              [value]="searchTerm$()"
              (input)="searchTerm$.set($any($event.target).value)"
            />
            <mat-icon
              class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 transform text-gray-400"
            >
              search
            </mat-icon>
          </div>
          <div class="flex items-center gap-2">
            <button
              type="button"
              class="inline-flex h-12 items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
              (click)="exportToCsv()"
              [disabled]="observations$.loading$() || filteredItemsCount$() === 0"
              aria-label="Download CSV"
            >
              <mat-icon class="!text-[20px]">download</mat-icon>
              Download
            </button>

            <select
              class="h-12 rounded-lg border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
              [ngModel]="selectedDuration$()"
              (ngModelChange)="selectedDuration$.set($event)"
              aria-label="Select duration"
            >
              @for (option of durationOptions; track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>
        </div>

        <app-p95-utilization-list
          [observations$]="observations$"
          [searchTerm]="searchTerm$()"
          [pageIndex]="pageIndex$()"
          [pageSize]="pageSize$()"
          class="mb-6 block w-full max-w-none self-stretch"
        />

        <div class="flex w-full justify-end">
          <mat-paginator
            [pageIndex]="pageIndex$()"
            [length]="filteredItemsCount$()"
            [pageSize]="pageSize$()"
            [pageSizeOptions]="[10, 25, 50, 100]"
            (page)="onPageChange($event)"
            aria-label="Select page"
            class="!p-0"
          ></mat-paginator>
        </div>
      </div>

      <aside class="p95-heatmap-legend" aria-label="Heatmap legend">
        <h4 class="legend-title">Site Utilization Heat Map</h4>
        <div class="legend-scale">
          <span>Low</span>
          <div class="legend-gradient" aria-hidden="true"></div>
          <span>High</span>
        </div>
        <p class="legend-body">
          Site values are color-coded by how heavily each site is used overall.
          Redder values mean higher utilization.
        </p>
      </aside>
    </div>
  </div>
</section>
